<mat-card style="box-shadow: none; padding: 0px !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
        <mat-card-title>QR Code Registration</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-dialog-content class="qr-content">
        <div style="text-align: center;" class="qr-container">
            <img [src]="qrCodeUrl" alt="QR Code" class="qr-code">
            <p style="font-weight: 500; font-size: 20px; color: #15457e;">Scan the QR code with your authenticator app.</p>
            <p>Manual entry key: {{ manualEntryKey }}</p>
            <p>Please enter the 2FA Code in the next screen</p>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions style="display: flex; justify-content: center;">
        <button
            style="font-size: 10px; margin-right: 5px; scale: 1; background: #bf1e2e; color: white; border-radius: 0px; text-shadow: none; box-shadow: none; flex: 1 1 100%; box-sizing: border-box; max-width: 50px; cursor: pointer; transition: background-color 0.3s;"
            mat-raised-button
            (click)="onCancelClick()"
        >Close</button>
    </mat-dialog-actions>
  </mat-card>
  